/**
 * Created by john on 7/27/15.
 */

'use strict';

const cartTracking = require('../../favorites/components/cart/cartTracking.es');
const CartStore = require('../stores/CartStore.es');
const NC = require('../core/nav/constants');
const mobileCheck = require('bunsen/helpers/mobileCheck');
const chatUtils = require('../utils/social/chat');

const cartActions = {

    /**
     * Navigates to the cart page.
     * @param actionContext
     * @param payload
     * @param done
     */
    goToCart: (actionContext, payload, done) => {
        const cartStore = actionContext.getStore(CartStore);
        window.location.href = cartStore.getCartUrl();
        done();
    },


    /**
     * Adds an item to the cart.
     * @param actionContext
     * @param payload
     * @param payload.item {Item} The Backbone item model to add
     * @param done
     */
    addToCart: (actionContext, payload, done) => {
        const {item} = payload;
        const cartStore = actionContext.getStore(CartStore);

        const loadImages = i => (i.get('images') || actionContext.executeAction(cartActions.updateItemModel, {item: i}));

        Promise.resolve(loadImages(item))
            .then(() => {
                if (!cartStore.isItemInCart(item)) {
                    actionContext.dispatch('cart:itemAdded', {item: item});
                    chatUtils.track.addToCart();
                    done();
                } else {
                    actionContext.dispatch('cart:itemExists', {item: item});
                    done();
                }
            })
            .catch(err => {
                done(err);
            });
    },


    /**
     * Adds an item to the cart and displays the nav bar hover menu. This is a separate action to avoid
     * adding extra if conditions to the 'addToCart' action.
     * @param actionContext
     * @param payload
     * @param done
     */
    addToCartAndNotify: (actionContext, payload, done) => {
        const {item} = payload;

        const redirectTo = null;

        actionContext.executeAction(cartActions.addToCart, {item})
            .then(() => {
                if (!redirectTo) {
                    actionContext.executeAction(cartActions.showRecentlyAddedItems, {items: [item]});
                } else {
                    window.location.href = redirectTo;
                }
                done();
            })
            .catch(err => {
                done(err);
            });
    },


    /**
     *
     * @param actionContext
     * @param payload
     * @param payload.item {Backbone.Model} The item to remove
     * @param payload.waitFor {Promise|Deferred} Wait for this in addition to the destroy() before dispatching.
     * @param done
     * @returns {*}
     */
    removeFromCart: (actionContext, payload, done) => {
        const {item, waitFor} = payload;

        const promises = [item.destroy()];
        if (waitFor) {
            promises.push(waitFor);
        }

        return Promise.all(promises)
            .then(() => {
                actionContext.dispatch('cart:itemRemoved', {item: item});
                done();
            })
            .catch(err => {
                actionContext.dispatch('cart:itemRemoved:error', {item: item, message: 'error deleting cart item'});
                done(err);
            });
    },

    removeFromCartById: (actionContext, payload, done) => {
        const cartStore = actionContext.getStore(CartStore);
        const item = cartStore.getItemById(payload.itemId);
        return cartActions.removeFromCart(actionContext, Object.assign({}, payload, { item }), done);
    },

    removeFromCartAtIndex: (actionContext, payload, done) => {
        const cartStore = actionContext.getStore(CartStore);
        const item = cartStore.getItemAtIndex(payload.index);
        return cartActions.removeFromCart(actionContext, Object.assign({}, payload, { item }), done);
    },

    /**
     * Triggers a fetch of the shopping cart to update the data, and dispatches
     * the appropriate message to the CartStore.
     * @param actionContext
     * @param payload
     * @param payload.track {boolean} True if a GA tracking event should be fired.
     * @param done
     */
    loadCartPortfolio: (actionContext, payload, done) => {
        const cartStore = actionContext.getStore(CartStore);
        const collection = cartStore.getItemsCollection();
        const {track} = payload;

        return Promise.resolve(collection.fetch())
            .then(() => {
                if (track) {
                    cartTracking.trackEcommerce('productImpression', collection.models);
                }
                return collection.length;
            })
            .then(itemCount => {
                actionContext.dispatch('cart:portfolio:loaded', {itemCount});
                done();
            })
            .catch(err => {
                actionContext.dispatch('cart:portfolio:error', {message: err});
                done(err);
            });
    },


    /**
     * Updates the item model and dispatches a notification to the store when complete.
     * This is mainly used to update the item's image for display in the cart dropdown menu.
     * @param actionContext
     * @param payload
     * @param payload.item {Item} The Backbone item model to update.
     * @param done
     */
    updateItemModel: (actionContext, payload, done) => {
        // TODO: maybe this should probably go in a more general 'portfolio actions' or 'item actions'
        const {item} = payload;

        actionContext.dispatch('item:update:start', {item});
        Promise.resolve(item.fetch())
            .then(() => {
                actionContext.dispatch('item:update:done', {item});
                done();
            })
            .catch(err => {
                actionContext.dispatch('item:update:failed', {err});
                done(err);
            });
    },


    /**
     * Displays the recently added item in the hover menu in the nav bar cart icon
     * @param actionContext
     * @param payload
     * @param payload.items {Array} The items to display in the menu
     * @param payload.timeout {Number} The number of milliseconds before the notification disappears
     * @param done
     */
    showRecentlyAddedItems: (actionContext, payload, done) => {
        const {items, timeout} = payload;
        const defaultTimeout = 7000;

        if (!mobileCheck.any()) {
            const el = document.getElementById(NC.TOGGLE_NAV_CART.replace(/#/, ''));
            if (el) {
                el.classList.add('is-hover');
                actionContext.dispatch('cart:notification:show', {items});
            }
            setTimeout(() => {
                actionContext.executeAction(cartActions.hideRecentlyAddedItems);
            }, timeout || defaultTimeout);
        }

        done();
    },


    /**
     * Hides the recently added items notification.
     * @param actionContext
     * @param payload
     * @param done
     */
    hideRecentlyAddedItems: (actionContext, payload, done) => {
        const el = document.getElementById(NC.TOGGLE_NAV_CART.replace(/#/, ''));
        if (el) {
            el.classList.remove('is-hover');
            actionContext.dispatch('cart:notification:hide');
        }
        done();
    }

};

module.exports = cartActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/cartActions.es.js